export const isPageVisible = (visibility: DocumentVisibilityState | null) => {
    switch (visibility) {
        case 'visible': {
            return true;
        }
        default:
        case 'hidden': {
            return false;
        }
    }
};

export const pageVisibilityChange = () => {
    let hidden;
    let visibilityChange;
    if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
        hidden = 'hidden',
        visibilityChange = 'visibilitychange';

    } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden',
        visibilityChange = 'msvisibilitychange';

    } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden',
        visibilityChange = 'webkitvisibilitychange';
    }

    return {
        hidden,
        visibilityChange
    };
};
